/* Remlagret – Boost V3 customization v4.18w-nosticky-lockoffset + MOBILE FIX PACK + MOBILE HOTFIX
   Fil: boost-sd-custom.js
   Scope: ENBART .boost-sd-container

   Ingen ex.moms-logik.

   Funktioner:
   - Vita kort, transparent lista
   - Titel exakt 2 rader (h2-stil)
   - Pris + compare på samma rad (gap: 45px desktop / kompakt i mobil)
   - Lagerstatus alltid längst ned i kortet
   - Recensionsyta reserveras alltid
   - Alla kort får samma höjd (equalizer) – men AV på mobil
   - Vänster filterpanel: VIT, rundade hörn, synlig scroll
   - NO STICKY/FIXED (panelen ligger kvar i flow)
   - LÅST topp-avstånd: beräknas en gång vid load (ingen scroll-uppdatering → inget hopp)
   - Collection header transparent, högerpanel utan border, toolbar transparent
   - Mobil (≤540px): 2 kolumner oavsett grid/flex, mindre kort (padding/typo/bild), mindre gap på prisrad, equalizer av
*/

(function () {
  const STYLE_ID = "__rem_boost_v418w_scoped__";
  const ROOT_SELECTOR = ".boost-sd-container";
  const MOBILE_BP_PX = 540;

  // ======= TUNABLES =======
  const LEFT_TOP_GAP = '85px';
  const LEFT_MAX_HEIGHT = '900px';

  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const getRoot = () => document.querySelector(ROOT_SELECTOR);

  // =========================
  //   HEADER-OFFSET DETECTION (LOCKED)
  // =========================
  const HEADER_SELECTORS = [
    'header',
    '#shopify-section-header',
    '.shopify-section-header',
    '.site-header',
    '.header',
    '.header-wrapper',
    '.announcement-bar',
    '.announcement-bar__outer',
    '[data-sticky-header]',
    '[data-header]',
    '[data-announce]'
  ];

  function isVisible(el) {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function measureHeaderOnce() {
    const cands = Array.from(new Set(
      HEADER_SELECTORS.flatMap(sel => Array.from(document.querySelectorAll(sel)))
    )).filter(isVisible);

    let maxH = 0;
    cands.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (Math.round(rect.top) <= 0) {
        maxH = Math.max(maxH, Math.ceil(rect.height));
      }
    });

    if (maxH === 0) {
      const hdr = document.querySelector('#shopify-section-header, .shopify-section-header, .site-header, header');
      if (isVisible(hdr)) maxH = Math.ceil(hdr.getBoundingClientRect().height);
    }
    return Math.max(0, maxH);
  }

  function setLockedOffsets() {
    const headerPx = measureHeaderOnce();
    document.documentElement.style.setProperty('--rem-header-offset-LOCKED', headerPx + 'px');
  }

  setLockedOffsets();
  window.addEventListener('resize', () => setLockedOffsets(), { passive: true });

  // =========================
  //   INJECT SCOPED CSS (BAS)
  // =========================
  if (!document.getElementById(STYLE_ID)) {
    const css = `
/* === Scope/bas === */
${ROOT_SELECTOR} {
  --boostsd-product-list-background-color: transparent !important;
  --boostsd-toolbar-bg: transparent !important;

  --rem-left-top-gap: ${LEFT_TOP_GAP};
  --rem-left-max-h: ${LEFT_MAX_HEIGHT};
  --rem-left-top-safe: calc(var(--rem-header-offset-LOCKED, 0px) + var(--rem-left-top-gap));
}

/* Lista transparent */
${ROOT_SELECTOR} .boost-sd__product-list-wrap,
${ROOT_SELECTOR} .boost-sd__product-list {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

/* Korten */
${ROOT_SELECTOR} .boost-sd__product-item {
  background: #fff !important;
  border: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  padding: 10px !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
${ROOT_SELECTOR} .boost-sd__product-item:hover {
  transform: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
}

/* Flex i link/info för inventory längst ned */
${ROOT_SELECTOR} .boost-sd__product-link {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
}
${ROOT_SELECTOR} .boost-sd__product-info {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 100% !important;
}

/* ======= TITEL – h2-stil (mindre, 2 rader) ======= */
${ROOT_SELECTOR} .boost-sd__product-title {
  font: inherit !important;
  font-size: 16px !important;
  line-height: 1.4 !important;
  font-weight: 600 !important;

  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;

  min-height: calc(1.4em * 2) !important;
  max-height: calc(1.4em * 2) !important;
  margin: 0 0 8px 0 !important;
}
${ROOT_SELECTOR} .boost-sd__product-title a {
  color: inherit !important;
  text-decoration: none !important;
}
${ROOT_SELECTOR} .boost-sd__product-title a:hover {
  text-decoration: underline !important;
}

/* ======= PRIS ======= */
${ROOT_SELECTOR} .boost-sd__product-price {
  display: block !important;
  text-align: left !important;
  white-space: normal !important;
}
${ROOT_SELECTOR} .boost-sd__product-price-content,
${ROOT_SELECTOR} .boost-sd__product-price-content--text-align-left {
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: baseline !important;
  white-space: nowrap !important;
  flex-wrap: nowrap !important;
  gap: 15px !important;
}
${ROOT_SELECTOR} .boost-sd__product-price .boost-sd__format-currency {
  font-size: 20px !important;
  line-height: 1.4 !important;
  font-weight: 600 !important;
}
${ROOT_SELECTOR} .boost-sd__product-price.is-discount
  .boost-sd__format-currency:not(.boost-sd__format-currency--price-compare) {
  color: #ee0000 !important;
}
${ROOT_SELECTOR} .boost-sd__product-price .boost-sd__format-currency--price-compare,
${ROOT_SELECTOR} .boost-sd__product-price > s {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #777 !important;
  text-decoration: line-through !important;
  opacity: 1 !important;
  display: inline !important;
  white-space: nowrap !important;
  vertical-align: baseline !important;
}

/* ======= Reviews-slot ======= */
${ROOT_SELECTOR} .boost-sd__integration-product-rating,
${ROOT_SELECTOR} .jdgm-prev-badge,
${ROOT_SELECTOR} .boost-sd__rating,
${ROOT_SELECTOR} .boost-sd__product-rating,
${ROOT_SELECTOR} .spr-badge,
${ROOT_SELECTOR} .rem-rating {
  display: block !important;
  min-height: 24px !important;
  margin: 4px 0 8px 0 !important;
  visibility: visible !important;
}
${ROOT_SELECTOR} .rem-rating-slot {
  display: block !important;
  min-height: 24px !important;
  margin: 4px 0 8px 0 !important;
  pointer-events: none !important;
  visibility: hidden !important;
}

/* Lagerstatus längst ned */
${ROOT_SELECTOR} .boost-sd__product-info > .boost-sd__inventory-status {
  margin-top: auto !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  align-self: flex-start !important;
}

/* Collection header transparent */
${ROOT_SELECTOR} .boost-sd__collection-header,
${ROOT_SELECTOR} .boost-sd__collection-header *,
${ROOT_SELECTOR} .boost-sd__collection-header::before,
${ROOT_SELECTOR} .boost-sd__collection-header::after {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

/* Högra panelen utan border */
${ROOT_SELECTOR} .boost-sd-right {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

/* Toolbar transparent */
${ROOT_SELECTOR} .boost-sd__toolbar-container,
${ROOT_SELECTOR} .boost-sd__toolbar {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* LEFT PANEL – ingen sticky, låst offset */
${ROOT_SELECTOR} .boost-sd-left {
  background: transparent !important;
  margin-top: var(--rem-left-top-safe) !important;
}
${ROOT_SELECTOR} .boost-sd__filter-tree-vertical-content {
  background: #fff !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
  position: static !important;
  max-height: var(--rem-left-max-h) !important;
  overflow: auto !important;
  -webkit-overflow-scrolling: touch !important;
  scrollbar-gutter: stable both-edges !important;
  width: inherit !important;
  max-width: 100% !important;
  margin: 0 auto !important;
}

/* Scrollbars */
${ROOT_SELECTOR} .boost-sd__filter-tree-vertical-content::-webkit-scrollbar {
  width: 10px; height: 10px;
}
${ROOT_SELECTOR} .boost-sd__filter-tree-vertical-content::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 999px;
}
`.trim();

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  // =========================
  //   JS HELPERS (DESKTOP DEFAULT)
  // =========================
  function ensurePriceRowLayout(root) {
    $$('.boost-sd__product-price-content, .boost-sd__product-price-content--text-align-left', root)
      .forEach(row => {
        row.style.setProperty('display','inline-flex','important');
        row.style.setProperty('flex-direction','row','important');
        row.style.setProperty('align-items','baseline','important');
        row.style.setProperty('white-space','nowrap','important');
        row.style.setProperty('flex-wrap','nowrap','important');
        row.style.setProperty('gap','45px','important'); // desktop default
      });
  }

  function ensureInventoryAtBottom(root) {
    $$('.boost-sd__product-info', root).forEach(info => {
      const inv = info.querySelector('.boost-sd__inventory-status');
      if (inv && info.lastElementChild !== inv) info.appendChild(inv);
    });
  }

  function ensureRatingSlot(root) {
    const ratingSelector = [
      '.boost-sd__integration-product-rating',
      '.jdgm-prev-badge',
      '.boost-sd__rating',
      '.boost-sd__product-rating',
      '.spr-badge',
      '.rem-rating'
    ].join(', ');
    $$('.boost-sd__product-info', root).forEach(info => {
      const hasRating = info.querySelector(ratingSelector);
      let placeholder = info.querySelector('.rem-rating-slot');

      if (!hasRating) {
        if (!placeholder) {
          const priceBlock = info.querySelector('.boost-sd__product-price, .boost-sd__product-price-content');
          placeholder = document.createElement('div');
          placeholder.className = 'rem-rating-slot';
          if (priceBlock && priceBlock.parentNode) {
            priceBlock.insertAdjacentElement('afterend', placeholder);
          } else {
            info.insertBefore(placeholder, info.firstChild);
          }
        }
      } else if (placeholder) {
        placeholder.remove();
      }
    });
  }

  function equalizeCardHeights(root) {
    const items = $$('.boost-sd__product-item', root);
    if (!items.length) return;
    items.forEach(el => el.style.minHeight = '');
    let maxH = 0;
    items.forEach(el => { const h = el.offsetHeight; if (h > maxH) maxH = h; });
    if (maxH > 0) items.forEach(el => el.style.minHeight = maxH + 'px');
  }

  function fixCollectionHeaderBg(root) {
    const hdr = root.querySelector('.boost-sd__collection-header');
    if (!hdr) return;
    hdr.style.setProperty('background','transparent','important');
    hdr.style.setProperty('border','0','important');
    hdr.style.setProperty('box-shadow','none','important');
  }

  function fixRightPanelBorder(root) {
    $$('.boost-sd-right', root).forEach(el => {
      el.style.setProperty('border','none','important');
      el.style.setProperty('border-left','none','important');
      el.style.setProperty('box-shadow','none','important');
      el.style.setProperty('background','transparent','important');
    });
  }

  function fixToolbarBg(root) {
    const targets = [
      '.boost-sd__toolbar-container',
      '.boost-sd__toolbar'
    ];
    targets.forEach(sel => {
      $$(sel, root).forEach(el => {
        el.style.setProperty('background','transparent','important');
        el.style.setProperty('box-shadow','none','important');
        el.style.setProperty('border','0','important');
        el.style.setProperty('backdrop-filter','none','important');
        el.style.setProperty('-webkit-backdrop-filter','none','important');
      });
    });
  }

  // =========================
  //   RUN ALL
  // =========================
  function runAll(root) {
    ensurePriceRowLayout(root);
    ensureInventoryAtBottom(root);
    ensureRatingSlot(root);
    fixCollectionHeaderBg(root);
    fixRightPanelBorder(root);
    fixToolbarBg(root);
    requestAnimationFrame(() => equalizeCardHeights(root));
  }

  // =========================
  //   MOBILE FIX PACK – gör hela kortet mindre + säkrar 2 kolumner
  // =========================

  // 1) Säkerställ 2 kolumner även om listan är FLEX (fallback)
  function forceTwoColumnsMobile(root) {
    const isMobile = window.matchMedia(`(max-width: ${MOBILE_BP_PX}px)`).matches;
    if (!isMobile) return;

    const list = $('.boost-sd__product-list', root);
    if (!list) return;

    const items = $$('.boost-sd__product-item', root);
    if (!items.length) return;

    const cs = getComputedStyle(list);
    const isGrid = cs.display.includes('grid');

    if (isGrid) {
      // Grid: säkerställ 2 kolumner
      list.style.setProperty('grid-template-columns', 'repeat(2, minmax(0,1fr))', 'important');
      list.style.setProperty('column-gap', '8px', 'important');
      list.style.setProperty('row-gap', '12px', 'important');
    } else {
      // Flex: slå på wrap och ge barnen 50% bredd
      list.style.setProperty('display', 'flex', 'important');
      list.style.setProperty('flex-wrap', 'wrap', 'important');
      list.style.setProperty('gap', '12px', 'important');

      // Ställ in bredd på korten (ta hänsyn till gap med calc)
      items.forEach((el) => {
        el.style.setProperty('box-sizing', 'border-box', 'important');
        el.style.setProperty('flex', '0 0 calc(50% - 6px)', 'important'); // 12px gap / 2
        el.style.setProperty('max-width', 'calc(50% - 6px)', 'important');
        el.style.setProperty('width', 'calc(50% - 6px)', 'important');
      });
    }
  }

  // 2) Mobil CSS – mindre typografi/spacing för HELA kortet (inte bara bilden)
  ;(function injectMobileCssFix(){
    const MOBILE_STYLE_ID = "__rem_boost_v418w_mobile_fix__";
    if (document.getElementById(MOBILE_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = MOBILE_STYLE_ID;
    style.textContent = `
@media (max-width: ${MOBILE_BP_PX}px) {

  /* Om temat kör grid: fånga här; annars tar JS-fallback över */
  ${ROOT_SELECTOR} .boost-sd__product-list {
    grid-template-columns: repeat(2, minmax(0,1fr)) !important;
    column-gap: 8px !important;
    row-gap: 12px !important;
  }

  /* HELA KORTET kompakt */
  ${ROOT_SELECTOR} .boost-sd__product-item {
    padding: 6px !important;
    border-radius: 10px !important;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08) !important;
  }

  /* Mindre bildhöjd */
  ${ROOT_SELECTOR} .boost-sd__product-item img {
    max-height: 110px !important;
    height: auto !important;
    width: 100% !important;
    object-fit: contain !important;
  }
 ${ROOT_SELECTOR} .boost-sd__product-image,
${ROOT_SELECTOR} .boost-sd__product-image-container,
${ROOT_SELECTOR} .boost-sd__image {
  max-height: 120px !important;

  /* NYTT: vit bakgrund och centrering */
  background: #fff !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

  /* Titel kompakt (fortfarande 2 rader) */
  ${ROOT_SELECTOR} .boost-sd__product-title {
    font-size: 12.5px !important;
    line-height: 1.3 !important;
    min-height: calc(1.3em * 2) !important;
    max-height: calc(1.3em * 2) !important;
    margin: 0 0 4px 0 !important;
  }

  /* Prisraden kompakt – gap finjusteras även i JS nedan */
  ${ROOT_SELECTOR} .boost-sd__product-price .boost-sd__format-currency {
    font-size: 15px !important;
    line-height: 1.25 !important;
    font-weight: 600 !important;
  }
  ${ROOT_SELECTOR} .boost-sd__product-price .boost-sd__format-currency--price-compare,
  ${ROOT_SELECTOR} .boost-sd__product-price > s {
    font-size: 11.5px !important;
  }

  /* Recensionsrad kompakt */
  ${ROOT_SELECTOR} .boost-sd__integration-product-rating,
  ${ROOT_SELECTOR} .jdgm-prev-badge,
  ${ROOT_SELECTOR} .boost-sd__rating,
  ${ROOT_SELECTOR} .boost-sd__product-rating,
  ${ROOT_SELECTOR} .spr-badge,
  ${ROOT_SELECTOR} .rem-rating,
  ${ROOT_SELECTOR} .rem-rating-slot {
    min-height: 16px !important;
    margin: 2px 0 4px 0 !important;
  }

  /* Lagerstatus kompakt */
  ${ROOT_SELECTOR} .boost-sd__product-info > .boost-sd__inventory-status {
    font-size: 11.5px !important;
    margin-top: auto !important;
  }

  /* Filtrens kort kompakt i mobil */
  ${ROOT_SELECTOR} .boost-sd__filter-tree-vertical-content {
    border-radius: 10px !important;
    max-height: 70vh !important;
  }
}
`;
    document.head.appendChild(style);
  })();

  // 3) Gapa ner prisraden ytterligare på mobil (JS-top-up)
  const _ensurePriceRowLayout_mobile_fix = ensurePriceRowLayout;
  ensurePriceRowLayout = function (root) {
    _ensurePriceRowLayout_mobile_fix(root);
    const isMobile = window.matchMedia(`(max-width: ${MOBILE_BP_PX}px)`).matches;
    const desiredGap = isMobile ? '18px' : '45px';
    $$('.boost-sd__product-price-content, .boost-sd__product-price-content--text-align-left', root)
      .forEach(row => row.style.setProperty('gap', desiredGap, 'important'));
  };

  // 4) Stäng av equalizer på mobil (låt korten krympa naturligt)
  const _equalizeCardHeights_mobile_fix = equalizeCardHeights;
  equalizeCardHeights = function (root) {
    const isMobile = window.matchMedia(`(max-width: ${MOBILE_BP_PX}px)`).matches;
    const items = $$('.boost-sd__product-item', root);
    items.forEach(el => el.style.minHeight = '');
    if (isMobile) return; // ingen equalize på små skärmar
    _equalizeCardHeights_mobile_fix(root);
  };

  // 5) Kör två-kolumners fallback varje gång vi re-renderar mobilen
  const _runAll_mobile_fix = runAll;
  runAll = function (root) {
    _runAll_mobile_fix(root);
    forceTwoColumnsMobile(root);
  };

  // =========================
  //   INIT
  // =========================
  function init() {
    const root = getRoot();
    if (!root) return;
    runAll(root);

    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => runAll(root));
      mo.observe(root, { childList:true, subtree:true, attributes:true, characterData:true });
    }

    setTimeout(() => runAll(root), 200);
    setTimeout(() => runAll(root), 800);

    window.addEventListener('resize', () => requestAnimationFrame(() => runAll(root)), { passive:true });
    window.addEventListener('load',  () => runAll(root));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ======= MOBILE HOTFIX: Force 2 columns & break full-width ======= */
(function mobileTwoColHotfix(){
  const ROOT_SELECTOR = ".boost-sd-container";
  const MOBILE_BP_PX = 540;

  // Högspecificerad CSS som vinner över temats mobilregler
  const HOTFIX_STYLE_ID = "__rem_boost_v418w_mobile_hotfix__";
  if (!document.getElementById(HOTFIX_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = HOTFIX_STYLE_ID;
    style.textContent = `
@media (max-width: ${MOBILE_BP_PX}px) {
  /* 1) Tvinga listan till grid med två kolumner */
  ${ROOT_SELECTOR} .boost-sd__product-list,
  ${ROOT_SELECTOR} .boost-sd__product-list.boost-sd__product-list,
  ${ROOT_SELECTOR} ul.boost-sd__product-list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    column-gap: 8px !important;
    row-gap: 12px !important;
    grid-auto-flow: row !important;
  }

  /* 2) Se till att barns width/flex inte tvingar fullbredd */
  ${ROOT_SELECTOR} .boost-sd__product-list > * {
    width: auto !important;
    max-width: none !important;
    min-width: 0 !important;
    flex: 0 0 auto !important;
    grid-column: auto / auto !important;
    margin: 0 !important;
  }

  /* 3) Vissa teman wrappar kortet i ytterligare ett element – neutralisera */
  ${ROOT_SELECTOR} .boost-sd__product-item,
  ${ROOT_SELECTOR} li.boost-sd__product-item,
  ${ROOT_SELECTOR} .boost-sd__grid-item,
  ${ROOT_SELECTOR} [data-boost-product-item] {
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto !important;
    grid-column: auto / auto !important;
  }

  /* 4) Kortet självt lite tajtare */
  ${ROOT_SELECTOR} .boost-sd__product-item {
    padding: 6px !important;
    border-radius: 10px !important;
  }
}
`;
    document.head.appendChild(style);
  }

  // JS-förstärkning som körs vid render och på resize
  function applyHotfix(root=document) {
    const isMobile = window.matchMedia(`(max-width: ${MOBILE_BP_PX}px)`).matches;
    if (!isMobile) return;

    const list = root.querySelector(
      `${ROOT_SELECTOR} .boost-sd__product-list, ${ROOT_SELECTOR} .boost-sd__grid, ${ROOT_SELECTOR} ul.boost-sd__product-list, ${ROOT_SELECTOR} [data-view="product-list"]`
    );
    if (!list) return;

    // Ta bort ev. "en kolumn på mobil"-klass om den finns
    list.classList.forEach(c => {
      if (/one[-_]?column|single[-_]?col|mobile[-_]?one/i.test(c)) list.classList.remove(c);
    });

    // Tvinga inline med !important (överstyr även inline från appen)
    list.style.setProperty('display', 'grid', 'important');
    list.style.setProperty('grid-template-columns', 'repeat(2, minmax(0, 1fr))', 'important');
    list.style.setProperty('column-gap', '8px', 'important');
    list.style.setProperty('row-gap', '12px', 'important');

    // Neutralisera barns fullbredd
    const items = Array.from(list.children);
    items.forEach(el => {
      el.style.setProperty('width', 'auto', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('flex', '0 0 auto', 'important');
      el.style.setProperty('grid-column', 'auto / auto', 'important');
      el.style.setProperty('margin', '0', 'important');
    });
  }

  // Kör direkt och vid DOM-ändringar
  function boot() {
    applyHotfix();
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    // MutationObserver – om Boost byter layout efter filtrering/pagination
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => applyHotfix(root));
      mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }

    // Säkerställ även vid resize och load
    window.addEventListener('resize', () => applyHotfix(root), { passive: true });
    window.addEventListener('load', () => applyHotfix(root));
    // Liten retry då vissa appar hydrerar sent
    setTimeout(() => applyHotfix(root), 200);
    setTimeout(() => applyHotfix(root), 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Start BOOST-14925 */
function getLabel(li) {
  const el = li.querySelector('.boost-sd__filter-option-item-label');
  return (el?.textContent || '').trim();
}

/** Get the numeric amount value inside parentheses from (xxx) */
function getAmount(li) {
  const el = li.querySelector('.boost-sd__filter-option-item-amount');
  if (!el) return NaN;
  const match = el.textContent.match(/\(([\d.,]+)\)/);
  return match ? parseFloat(match[1].replace(',', '.')) : NaN;
}

/** Normalize: replace comma with dot and extract the first numeric token */
function getNumeric(str) {
  const m = String(str).replace(',', '.').match(/[\d.]+/);
  return m ? parseFloat(m[0]) : NaN;
}

/** Comparator #2: compare by numeric part only, ignore units */
function compareByNumericOnly(a, b) {
  const na = getNumeric(getLabel(a));
  const nb = getNumeric(getLabel(b));
  const aNaN = Number.isNaN(na);
  const bNaN = Number.isNaN(nb);

  if (aNaN && bNaN) {
    return getLabel(a).localeCompare(getLabel(b), undefined, { numeric: true });
  }
  if (aNaN) return 1;
  if (bNaN) return -1;
  if (na !== nb) return na - nb;
  return getLabel(a).localeCompare(getLabel(b), undefined, { numeric: true });
}

/** Comparator #3: compare by amount value */
function compareByAmount(a, b) {
  const va = getAmount(a);
  const vb = getAmount(b);
  const aNaN = Number.isNaN(va);
  const bNaN = Number.isNaN(vb);

  if (aNaN && bNaN) return 0;
  if (aNaN) return 1;
  if (bNaN) return -1;
  return va - vb;
}

/**
 * Sort a UL by given comparator, direction ('asc' | 'desc'),
 * and target ('label' | 'amount')
 */
function sortUl(parentElm, ulOrSelector, comparator, direction = 'asc', target = 'label') {
  const ul = typeof ulOrSelector === 'string'
    ? parentElm.querySelector(ulOrSelector)
    : ulOrSelector;
  if (!ul) return;

  const items = Array.from(ul.querySelectorAll(':scope > li'));
  items.sort((a, b) => {
    let result;
    if (target === 'amount') result = compareByAmount(a, b);
    else result = comparator(a, b);
    return direction === 'desc' ? -result : result;
  });

  const frag = document.createDocumentFragment();
  for (const li of items) frag.appendChild(li);
  ul.appendChild(frag);
}

function isNumeric(parentElm, ulOrSelector) {
    const ul = typeof ulOrSelector === 'string'
    ? parentElm.querySelector(ulOrSelector)
    : ulOrSelector;
  if (!ul) return false;
  const items = Array.from(ul.querySelectorAll(':scope > li'));

  if (items.length < 1) return false;

  return items.every(element => {
    const na = getNumeric(getLabel(element));
    return !Number.isNaN(na);  // true if numberic, false if not
  });

}


function sortOptionList(parentElm, selector, mode = 'volume', direction = 'asc', target = 'label') {
  sortUl(parentElm, selector, compareByNumericOnly, direction, target);
}
const sortByNum = 'numeric'

const map = {
  'key-asc': { mode: sortByNum, direction: 'asc', target: 'label' },
  'key-desc': { mode: sortByNum, direction: 'desc', target: 'label' },
  'doc_count-asc': { mode: sortByNum, direction: 'asc', target: 'amount' },
  'doc_count-desc': { mode: sortByNum, direction: 'desc', target: 'amount' },
};



const customizeProductItem = {
  changeFilterOrder: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItemWidget', {
            name: 'Add product type',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                      try {
                          const bwi = window.boostWidgetIntegration;
                          const boostLabels = document.querySelectorAll('.boost-sd__filter-option.boost-sd__filter-option');

                          boostLabels.forEach(element => {
                            if (isNumeric(element, '.boost-sd__filter-option-listitem')) {
        
                              const test = element.querySelector('.boost-sd__filter-option-title');
                              const cfg = map['key-asc'];
                              if (cfg) sortOptionList(element, '.boost-sd__filter-option-listitem', cfg.mode , cfg.direction, cfg.target);
                              
                            }
                          });               

                      } catch (e) {
                        console.log('err', e)
                      }
                },
            }),
        });
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customizeProductItem.changeFilterOrder
]);
/* End BOOST-14925 */